import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.a`
  color: ${props => props.theme.primaryColor};
  text-transform: uppercase;
  text-align: center;
  background-color: ${props => props.theme.primaryColorTransparent};
  margin: 0px 10px 10px 0px;
  font-size: 12px;
  font-weight: ${props => props.theme.fontWeightBold};
  line-height: 24px;
  border-radius: 2px;
  min-width: 4.6em;
  display: inline-block;
  padding: 0 10px;

  &&:hover {
    text-decoration: none;
  }
`;

export default function Keyword({ keyword }) {
  return (
    <Container
      href={`/keywords/${keyword.slug}`}
      data-keyword={keyword.value}
    >
      {keyword.value}
    </Container>
  );
}

Keyword.propTypes = {
  keyword: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};
